export default [{
  path: '/question-category-list',
  name: 'questionCategoryList',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/quiz/questionCategoryList/index')
}]
